import { useVeroFlag } from "shared/utils/featureFlags";
import { VeroFlag } from "shared/utils/veroFlags";

/**
 * Custom hook to check if configuration settings are locked
 * Returns whether the user can edit configuration settings
 * 
 * @returns {Object} { isLocked: boolean, canEdit: boolean }
 * - isLocked: true if configuration is locked (read-only mode)
 * - canEdit: true if user can edit configuration (opposite of isLocked)
 */
export const useConfigLock = () => {
  const canEdit = useVeroFlag(VeroFlag.canEditDealConfiguration, false);
  
  return {
    isLocked: !canEdit,
    canEdit,
  };
};

